import { ActivatedRoute } from "@angular/router";
// import { BaseDetails, FormRequest, FormResponse, Messages, FormSaveResponse } from '../../../modules/tcm-core.module';
import { TcmBaseComponentContext } from "../services/tcm-base-component-context.service";
import { Subscription } from 'rxjs/internal/Subscription';
import { Directive } from "@angular/core";
import { BroadCastEvents } from "../../../common/broad-cast-events.enum";
import { FormRequest } from "../../tcm-core.module/models/details/form-request";
import { FormResponse } from "../../tcm-core.module/models/details/form-response";
import { FormSaveResponse } from "../../tcm-core.module/models/details/form-save-response";
import { BaseDetails } from "../../tcm-core.module/components/base-details/base-details";

@Directive()
export class TcmBaseDetails<TFormRequest extends FormRequest, TFormResponse extends FormResponse<any>, TFormSaveResponse extends FormSaveResponse = FormSaveResponse> extends BaseDetails<TFormRequest, TFormResponse, TFormSaveResponse> {

    private readonly _commonSubscriptions: Subscription[] = [];
    private errorSubscription: Subscription;

    constructor(protected override componentContext: TcmBaseComponentContext, protected override route: ActivatedRoute) {
        super(componentContext, route);

        this.errorSubscription = this.componentContext.broadcastService
            .getEvents(BroadCastEvents.ServerErrorOccurred)
            .subscribe((e) => { this.isLoading = false; });
    }

    
    override ngOnDestroy(){
        super.ngOnDestroy();

        for(let s of this._commonSubscriptions){
            s.unsubscribe();
        }

        this.errorSubscription.unsubscribe();
    }

    protected getUserConfirmationOnExitAsync(): Promise<boolean> {
        return this.componentContext.modalService.showConfirmationModalAsync(
            x => x.Messages.MessageHeadersAndActions.Warning,
            x => x.Messages.WarningMessages.LeaveConfirmationMessage);
    }

    protected async wrapRemoteCallAsync<T = any>(executor: () => Promise<T>): Promise<T> {

        const isLoadingByParent = this.isLoading;

        try {

            this.isLoading = true;

            const result = await executor();

            return result;
        }
        finally {
            if (!isLoadingByParent)
                this.isLoading = false;
        }
    }

    protected addCommonSubscription(...subscriptions: Subscription[]){
        this._commonSubscriptions.push(...subscriptions);
    }
}